const set = property => (state, payload) => (state[property] = payload)
const get = property => (state) => (state[property])

export default {
  namespaced: true,
  state: {
    userInfo: null,
    cloudConstructionList: null,
    s3Info: null,
    kokubandataList: null,
    updateCloudConstructionInfo: null,
    sentKokubanWithTimeout: null,
    cloudConstructionInfo: null,
    wordList: null,
  },
  getters: {
    userInfo: get('userInfo'),
    cloudConstructionList: get('cloudConstructionList'),
    s3Info: get('s3Info'),
    kokubandataList: get('kokubandataList'),
    updateCloudConstructionInfo: get('updateCloudConstructionInfo'),
    sentKokubanWithTimeout: get('sentKokubanWithTimeout'),
    cloudConstructionInfo: get('cloudConstructionInfo'),
    wordList: get('wordList'),
  },
  mutations: {
    setUserInfo: set('userInfo'),
    setCloudConstructionList: set('cloudConstructionList'),
    setS3Info: set('s3Info'),
    setKokubandataList: set('kokubandataList'),
    setUpdateCloudConstructionInfo: set('updateCloudConstructionInfo'),
    setSentKokubanWithTimeout: set('sentKokubanWithTimeout'),
    setCloudConstructionInfo: set('cloudConstructionInfo'),
    setWordList: set('wordList'),
  },
}
